<template>
    <div>
        <div class="holder">

            <div class="top-header">
                <div>
                    <p @click="backBtn()" class="back-text"><span><i class="fa fa-chevron-left"></i></span>Back</p>
                    <h3>Tenant Onboarding Form</h3>
                </div>
                <h6>Please fill out the required details below to help us create and manage your tenancy profile efficiently.</h6>
            </div>
            <hr>

            <div class="top-buttons">
                <button class="btn" :class="[formtype == 1 ? 'activeBtn' : '']" @click="formtype = 1">Biodata</button>
                <button class="btn" :class="[formtype == 2 ? 'activeBtn' : '']" @click="formtype = 2">In Case of Emergency</button>
                <button class="btn" :class="[formtype == 3 ? 'activeBtn' : '']" @click="formtype = 3">Means of Identification</button>
                <button class="btn" :class="[formtype == 4 ? 'activeBtn' : '']" @click="formtype = 4">Guarantor Information</button>
                <button class="btn" :class="[formtype == 5 ? 'activeBtn' : '']" @click="formtype = 5">Next of Kin</button>
                <button class="btn" :class="[formtype == 6 ? 'activeBtn' : '']" @click="formtype = 6">Occupation</button>
            </div>


            <div class="container-fluid mt-5">
                <div class="biodata-form" v-if="formtype == 1">
                    
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="firstname">First name</label>
                                        <input v-model="firstname" type="text" class="form-control" id="firstname" placeholder="First name">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="lastname">Last name</label>
                                        <input v-model="lastname" type="text" class="form-control" id="lastname" placeholder="Last name">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="others">Other name</label>
                                        <input v-model="othernames" type="text" class="form-control" id="others" placeholder="Other name">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gender">Gender</label>
                                    <select class="form-control" id="gender" v-model="gender">
                                        <option selected disabled value="">Select gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="phone">Phone number</label>
                                        <input v-model="phone" type="text" class="form-control" placeholder="Phone Number">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="address">Email address</label>
                                        <input v-model="email" type="text" class="form-control" id="address" placeholder="Email address">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <div class="form-group">
                                        <label for="">Date of birth</label>
                                        <input v-model="dob" :max="maxBirthDate" type="date" class="form-control" placeholder="date of birth">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="state">State</label>
                                    <select class="form-control dynamic-input" name="state" id="state" v-model="stateId">
                                        <option value="" disabled slected>Select state</option>
                                        <option
                                            v-for="state in states"
                                            :key="state.id"
                                            :value="state.id"
                                            
                                            >{{ state.name }}</option
                                        >
                                    </select>
                                </div>
                            </div>
                            <!-- <div class="col-md-6"></div> -->
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitBioData">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="formtype == 2">
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="efname">First name</label>
                                    <input v-model="efname" type="text" class="form-control" id="efname" placeholder="First name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="elname">Last name</label>
                                    <input v-model="elname" type="text" class="form-control" id="elname" placeholder="Last name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="ephone">Phone</label>
                                    <input v-model="ephone" type="text" class="form-control" id="ephone" placeholder="Phone">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="relationship">Relationship</label>
                                    <select class="form-control" id="relationship" v-model="relationship">
                                        <option selected disabled value="">Select</option>
                                        <option value="husband">Husband</option>
                                        <option value="wife">Wife</option>
                                        <option value="son">Son</option>
                                        <option value="daughter">Daughter</option>
                                        <option value="father">Father</option>
                                        <option value="mother">Mother</option>
                                        <option value="brother">Brother</option>
                                        <option value="sister">Sister</option>
                                        <option value="friend">Friend</option>
                                        <option value="colleague">Colleague</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="eaddress">Address</label>
                                    <input v-model="eaddress" type="text" class="form-control" id="eaddress" placeholder="Address">
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitEmagencyData()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div> 
                
                <div v-if="formtype == 3">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="identificationType">Means of Identification</label>
                                <select class="form-control" id="identificationType" v-model="identificationType">
                                    <option selected disabled value="">Select document type</option>
                                    <option value="national identification number">National Identification Number(NIN)</option>
                                    <option value="direvers licence">Direvers Licence</option>
                                    <option value="voters card">Voters Card</option>
                                    <option value="passport">Passport</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6">
                            <div class="upload-identification form-group" @click="idSelection">
                                <img src="../assets/icons/upload.svg" alt="">
                                <h5>Click to upload identification</h5>
                                <h6>{{ identificationFile.name }}</h6>
                            </div>
                            <input type="file" ref="identification" class="d-none" @change="handleFileUploadIdentification($event)">
                        </div>
                    </div>

                    <div class="row d-flex justify-content-center">
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="uploadDoc()">Upload
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="formtype == 4">
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gfname">First name</label>
                                    <input v-model="gfname" type="text" class="form-control" id="gfname" placeholder="First name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="glname">Last name</label>
                                    <input v-model="glname" type="text" class="form-control" id="glname" placeholder="Last name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="ephone">Phone</label>
                                    <input v-model="gphone" type="text" class="form-control" id="gphone" placeholder="Phone">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gemail">Email</label>
                                    <input v-model="gemail" type="text" class="form-control" id="gemail" placeholder="Email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gaddress">Address</label>
                                    <input v-model="gaddress" type="text" class="form-control" id="gaddress" placeholder="Address">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="grelationship">Relationship</label>
                                    <select class="form-control" id="grelationship" v-model="grelationship">
                                        <option selected disabled value="">Select</option>
                                        <option value="husband">Husband</option>
                                        <option value="wife">Wife</option>
                                        <option value="son">Son</option>
                                        <option value="daughter">Daughter</option>
                                        <option value="father">Father</option>
                                        <option value="mother">Mother</option>
                                        <option value="brother">Brother</option>
                                        <option value="sister">Sister</option>
                                        <option value="friend">Friend</option>
                                        <option value="colleague">Colleague</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitGuarantorData()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div> 

                <div v-if="formtype == 5">
                    <div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nfname">First name</label>
                                    <input v-model="nfname" type="text" class="form-control" id="nfname" placeholder="First name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nlname">Last name</label>
                                    <input v-model="nlname" type="text" class="form-control" id="nlname" placeholder="Last name">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nphone">Phone</label>
                                    <input v-model="nphone" type="text" class="form-control" id="nphone" placeholder="Phone">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nemail">Email</label>
                                    <input v-model="nemail" type="text" class="form-control" id="nemail" placeholder="Email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="naddress">Address</label>
                                    <input v-model="naddress" type="text" class="form-control" id="naddress" placeholder="Address">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nrelationship">Relationship</label>
                                    <select class="form-control" id="nrelationship" v-model="nrelationship">
                                        <option selected disabled value="">Select</option>
                                        <option value="husband">Husband</option>
                                        <option value="wife">Wife</option>
                                        <option value="son">Son</option>
                                        <option value="daughter">Daughter</option>
                                        <option value="father">Father</option>
                                        <option value="mother">Mother</option>
                                        <option value="brother">Brother</option>
                                        <option value="sister">Sister</option>
                                        <option value="friend">Friend</option>
                                        <option value="colleague">Colleague</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitNextOfKinData()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div> 

                <div v-if="formtype == 6">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6">
                            <div class="form-group">
                                <!-- <label for="occupation">Occupation type</label> -->
                                <select class="form-control dynamic-input" name="occupation" id="occupation" v-model="occupationId">
                                    <option value="" disabled>Select occupation type</option>
                                    <option
                                        v-for="item in occupationTypes"
                                        :key="item.id"
                                        :value="item.id"
                                        >{{ item.occupation }}</option
                                    >
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-if="occupationId == '1' || occupationId == '2' || occupationId == '3'">
                        <div>
                            <div class="row d-flex justify-content-center">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="businessname">Business Name</label>
                                        <input v-model="businessname" type="text" class="form-control" id="businessname" placeholder="Business name">
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row d-flex justify-content-center">
                                

                                <div class="col-md-6">
                                    <div class="">
                                        <div class="form-group">
                                            <label for="businessaddress">Business Address</label>
                                            <input v-model="businessaddress" type="text" class="form-control" id="businessaddress" placeholder="Business address">
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row d-flex justify-content-center">
                                

                                <div class="col-md-6">
                                    <div class="">
                                        <div class="form-group">
                                            <label for="businesssector">Business Sector</label>
                                            <input v-model="businesssector" type="text" class="form-control" id="businesssector" placeholder="Business sector">
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row d-flex justify-content-center">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="isregistered">Is Business Registered?</label>
                                        <select class="form-control" id="isregistered" v-model="isregistered">
                                            <option selected disabled value="">Select</option>
                                            <option value="YES">YES</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row d-flex justify-content-center" v-if="isregistered == 'YES'">
                                <div class="col-md-6">
                                    <div class="">
                                        <div class="form-group">
                                            <label for="registrationtype">Registration Type</label>
                                            <select class="form-control" id="isregistered" v-model="registrationtype">
                                            <option selected disabled value="">Select</option>
                                            <option value="business name">Business Name</option>
                                            <option value="limited liability company">Limited Liability Company</option>
                                            <option value="incorpurated trustee">Incorpurated Trustee</option>
                                        </select>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="row d-flex justify-content-center" v-if="isregistered == 'YES'">
                                <div class="col-md-6">
                                    <div class="">
                                        <div class="form-group">
                                            <label for="registrationnumber">Registration Number</label>
                                            <input v-model="registrationnumber" type="text" class="form-control" id="registrationnumber" placeholder="Business registration number">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex justify-content-center" v-if="isregistered == 'YES'">
                                <div class="col-md-6">
                                    <div class="">
                                        <div class="form-group">
                                            <label for="certificateofincoporation">Certificate of Incoporation name</label>
                                            <input v-model="certificateofincoporation" type="text" class="form-control" id="certificateofincoporation" placeholder="Certificate Of Incoporation">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitBusinessEmployed()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>

                    <div v-if="occupationId == '5' || occupationId == '7'">
                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nameoforganisation">Organisation Name</label>
                                    <input v-model="nameoforganisation" type="text" class="form-control" id="nameoforganisation" placeholder="Organisation name">
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nameoforganisation">Job Title</label>
                                    <input v-model="jobtitle" type="text" class="form-control" id="jobtitle" placeholder="Job Title">
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="ngoeaddress">Address</label>
                                    <input v-model="ngoeaddress" type="text" class="form-control" id="ngoeaddress" placeholder="Organization Address">
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="ngoephone">Organization Phone</label>
                                    <input v-model="ngoephone" type="text" class="form-control" id="ngoephone" placeholder="Organization Phone">
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dateofemployment">Date of Employment</label>
                                    <input v-model="dateofemployment" type="date" :max="today" class="form-control" id="dateofemployment" placeholder="Date Employed">
                                </div>
                            </div>
                        </div>

                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitEmployedNgo()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>

                    <div v-if="occupationId == '4' || occupationId == '6'">
                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="lastworkplace">Last Place of Employment</label>
                                    <input v-model="lastworkplace" type="text" class="form-control" id="lastworkplace" placeholder="Last place of employment">
                                </div>
                            </div>
                            
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dateofdisengagement">Date of Disengagement</label>
                                    <input v-model="dateofdisengagement" type="date" :max="today" class="form-control" id="dateofdisengagement" placeholder="Date of disengagement">
                                </div>
                            </div>
                            
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="uaddress">Address</label>
                                    <input v-model="uaddress" type="text" class="form-control" id="uaddress" placeholder="Address">
                                </div>
                            </div>
                            
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="uphone">Last employer phone</label>
                                    <input v-model="uphone" type="text" class="form-control" id="uphone" placeholder="Employer Phone">
                                </div>
                            </div>
                            
                        </div>

                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="currentsourceofincome">Current Source of Income</label>
                                    <input v-model="currentsourceofincome" type="text" class="form-control" id="currentsourceofincome" placeholder="Current source of income">
                                </div>
                            </div>
                            
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="loading" class="btn save-btn" @click="submitUnemployedRetired()">Save
                                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</template>



<script>
import properties from '../services/properties';


export default {
    name: "TenantOnboarding",
    // props: {
    //     emptyData: {
    //         type: Object,
    //         required: true,
    //     }
    // },
    data() {
        return {
            loading: false,
            formtype: 1,
            states: "",
            loadingStates: [],
            stateId: "",
            propertyPin: "",
            firstname: "",
            lastname: "",
            othernames: "",
            email: "",
            phone: "",
            gender: "",
            dob: "",
            tenantId: "",

            eaddress: "",
            efname: "",
            elname: "",
            ephone: "",
            relationship: "",

            identificationFile: "",
            identificationType: "",

            gfname: "",
            glname: "",
            gphone: "",
            gemail: "",
            grelationship: "",
            gaddress: "",

            nfname: "",
            nlname: "",
            nphone: "",
            nemail: "",
            nrelationship: "",
            naddress: "",

            occupationTypes: [],
            occupationId: "",

            isregistered: "",
            businessaddress: "",
            businessname: "",
            businesssector: "",
            registrationtype: "",
            registrationnumber: "",
            certificateofincoporation: "",

            ngoeaddress: "",
            ngoephone: "",
            jobtitle: "",
            nameoforganisation: "",
            dateofemployment: "",
            today: new Date().toISOString().split("T")[0] , // 'YYYY-MM-DD' format

            currentsourceofincome: "",
            lastworkplace: "",
            uaddress: "",
            dateofdisengagement: "",
            uphone: "",

            emergency: {
                firstname: "",
                lastname: "",
                phone: "",
                relationship: "",
                address: ""
            },

            tenantOtherDetails: "",
        }
    },
    created() {
        this.propertyPin = this.$route.params.id;
    },
    computed: {
        maxBirthDate() {
        const today = new Date()
        today.setFullYear(today.getFullYear() - 18)
        return today.toISOString().split('T')[0]  // 'YYYY-MM-DD'
        }
        
    },
    mounted() {
        // console.log("fetch user data Onboading", this.$store.getters.isOnboarding);
        this.getStates();
        this.getOccupationTypes();
        if (this.$store.getters.isOnboarding != null) {
            this.storedTenantDetails();
        }
        // this.$store.commit("clearTenantData")
    },
    methods: {
        backBtn() {
            // this.$router.push({path: `/user/partner/property-details/${this.unitBatch}`});
            this.$router.go(-1)
        },
        getStates() {
            this.loadingStates = true;
            properties.fetchStates().then((data) => {
                // console.log("states", data)
                this.loadingStates = false;
                this.states = data.states;
            }).catch((err) => {
               console.log(err);
            });
        },
        storedTenantDetails() {
            this.tenantDetailsStored = this.$store.getters.isOnboarding.user_object;
            this.tenantOtherDetails= this.$store.getters.isOnboarding;
            this.tenantId = this.$store.getters.isOnboarding.user_object.id;

            this.firstname = this.tenantDetailsStored.firstname;
            this.lastname = this.tenantDetailsStored.lastname;
            this.othernames = this.tenantDetailsStored.othernames;
            this.gender = this.tenantDetailsStored.gender;
            this.phone = this.tenantDetailsStored.phone;
            this.email = this.tenantDetailsStored.email;
            this.dob = this.tenantDetailsStored.dob;
            this.stateId = this.tenantDetailsStored.stateid;

            // this.emergency = this.tenantDetailsStored.emergency;
            // emergency data starts
            if (this.tenantOtherDetails.emergency_details != null) {
                const [efirstname, elastname] = this.tenantOtherDetails.emergency_details.fullname.split(" ", 2);
                this.efname = efirstname;
                this.elname = elastname;
                this.ephone = this.tenantOtherDetails.emergency_details.phone;
                this.relationship = (this.tenantOtherDetails.emergency_details.relationship).toLowerCase();
                this.eaddress = this.tenantOtherDetails.emergency_details.address;
            }
            // emergency data ends

            

            // Guarentor data starts
            if (this.tenantOtherDetails.gurantor != null ) {
                const [gfname, glname] = this.tenantOtherDetails.gurantor.fullname.split(" ", 2);
                this.gfname = gfname;
                this.glname = glname;
                this.gphone =  this.tenantOtherDetails.gurantor.phone;
                this.gemail =  this.tenantOtherDetails.gurantor.email;
                this.gaddress = this.tenantOtherDetails.gurantor.address;
                this.grelationship =  (this.tenantOtherDetails.gurantor.relationship).toLowerCase();
            }
            // Guarentor data ends

            // Next of kin data starts
            if (this.tenantOtherDetails.nextofkin != null ) {
               if (this.tenantOtherDetails.nextofkin.fullname != null) {
                const [nfname, nlname] = this.tenantOtherDetails.nextofkin.fullname.split(" ", 2);
                this.nfname = nfname;
                this.nlname = nlname;
                this.nphone =  this.tenantOtherDetails.nextofkin.phone;
                this.nemail =  this.tenantOtherDetails.nextofkin.email;
                this.naddress = this.tenantOtherDetails.nextofkin.address;
                this.nrelationship =  (this.tenantOtherDetails.nextofkin.relationship).toLowerCase();
               }
            }
            // Next of kin data ends

            // Occupatipn data starts
            if(this.tenantOtherDetails.selfemployed_details != null) {
                this.occupationId = '2';
                this.businessname = this.tenantOtherDetails.selfemployed_details.nameofbusiness;
                this.businessaddress = this.tenantOtherDetails.selfemployed_details.businessaddress;
                this.businesssector = this.tenantOtherDetails.selfemployed_details.businesssector;
                if (this.tenantOtherDetails.selfemployed_details.isregistered == '1') {
                    this.isregistered = 'YES';
                    this.registrationtype = (this.tenantOtherDetails.selfemployed_details.registrationtype).toLowerCase();
                    this.registrationnumber = this.tenantOtherDetails.selfemployed_details.regnumber;
                    this.certificateofincoporation = this.tenantOtherDetails.selfemployed_details.certificateofincoporation;

                }
                else {
                    this.isregistered = 'NO';
                }

            }
            if(this.tenantOtherDetails.unemployed != null) {
                this.occupationId = '4';
                this.lastworkplace = this.tenantOtherDetails.unemployed.lastworkplace;
                this.dateofdisengagement = this.tenantOtherDetails.unemployed.dateofdisengagement;
                this.uaddress =  this.tenantOtherDetails.unemployed.address;
                this.uphone = this.tenantOtherDetails.unemployed.phone;
                this.currentsourceofincome = this.tenantOtherDetails.unemployed.currentsourceofincome;
            }
            if(this.tenantOtherDetails.employeddetails != null) {
                this.occupationId = '7';
                this.jobtitle = this.tenantOtherDetails.employeddetails.jobtitle;
                this.nameoforganisation =  this.tenantOtherDetails.employeddetails.nameoforganisation;
                this.uaddress = this.tenantOtherDetails.employeddetails.address;
                this.dateofdisengagement = this.tenantOtherDetails.employeddetails.dateofemployment;
                this.uphone = this.tenantOtherDetails.employeddetails.phone;
            }
            // Occupation data ends

        },
        async submitBioData() {
            if (
                this.firstname == "" || this.email == "" || this.phone == "" || this.gender == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            if (this.propertyPin == "") {
                this.$toast.error("No property pin");
                return;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.email)) {
                return this.$toast.error("Email format not correct");
            }

            const birth = new Date(this.dob)
            const today = new Date()
            let age = today.getFullYear() - birth.getFullYear()
            const m = today.getMonth() - birth.getMonth()

            if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
                age--
            }

            if (age < 18) {
                this.errorMessage = 'You must be at least 18 years old.'
                return;
            } 
            let payload = {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                othernames: this.othernames,
                stateid: this.stateId,
                gender: this.gender,
                phone: this.phone,
                dob: this.dob,
                property_pin: this.propertyPin,
            }
            this.loading = true;
            try {
                await properties.tenantBioData(JSON.stringify(payload)).then(res => {
                    // console.log("Biodata", res);
                    this.loading = false;
                    this.tenantId =  res.tenant_id;
                    if (res.success) {
                        
                        this.$store.commit("clearTenantData")
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },

        async submitEmagencyData() {
            if (
                this.efname == "" || this.elname == "" || this.relationship == "" || this.ephone == "" || this.eaddress == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            let payload = {
                fullname: `${this.efname} ${this.elname}`,
                relationship: this.relationship,
                phone: this.ephone,
                address: this.eaddress,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantEmagencyData(JSON.stringify(payload)).then(res => {
                    // console.log("Emagency", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },
        idSelection() {
            this.$refs.identification.click();
        },
        handleFileUploadIdentification(event) {
            this.identificationFile = event.target.files[0];
            // console.log("File id", this.identificationFile)
            if (
            this.identificationFile.type !== "image/jpeg" &&
            this.identificationFile.type !== "image/png" &&
            this.identificationFile.type !== "image/svg+xml" &&
            this.identificationFile.type !== "application/pdf"
        ) {
            return this.$toast.error(
            "Document must only be in either image or pdf format"
            );
        }
        },
        uploadDoc() {
        if (this.identificationType == "") {
            return this.$toast.error("Select identification type");
        }
        if (!this.identificationFile) {
            return this.$toast.error("Select a file");
        }
        this.loading = true;

        let formData = new FormData();

        formData.append("tenant_id", +this.tenantId);
        formData.append("file", this.identificationFile);
        formData.append("documentType", this.identificationType);

        properties
            .tenantMeansOfID(formData)
            .then(data => {
                this.loading = false;
                if (data.success) {
                    this.$toast.success(data.success);
                } else {
                    // this.identificationFile = "";
                    this.$toast.error(data.error);
                }
            })
            .catch((err) => {
            // this.identificationFile = "";
            this.loading = false;
            console.log(err);
            // this.$toast.error("please check your network and refresh the page");
            });
        },
        
        async submitGuarantorData() {
            if (
                this.gfname == "" || this.glname == "" || this.gemail == "" || this.grelationship == "" || this.gphone == "" || this.gaddress == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            let payload = {
                fullname: `${this.gfname} ${this.glname}`,
                relationship: this.grelationship,
                phone: this.gphone,
                email: this.gemail,
                address: this.gaddress,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantGuarantorData(JSON.stringify(payload)).then(res => {
                    // console.log("Guarantor", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },

        async submitNextOfKinData() {
            if (
                this.nfname == "" || this.nlname == "" || this.nemail == "" || this.nrelationship == "" || this.nphone == "" || this.naddress == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            let payload = {
                fullname: `${this.nfname} ${this.nlname}`,
                relationship: this.nrelationship,
                phone: this.nphone,
                email: this.nemail,
                address: this.naddress,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantNextOfKinData(JSON.stringify(payload)).then(res => {
                    // console.log("Next of Kin", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },
        getOccupationTypes() {
            properties.fetchOccupationTypes().then(res => {
                // console.log("Occupation types", res);
                if (res.success) {
                    this.occupationTypes = res.occupation;
                }
            }).catch((err) => {
                console.log(err);
                this.loading = false;
            });
        },

        async submitBusinessEmployed() {
            if (
                this.businessname == "" || this.businesssector == "" || this.businessaddress == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            if (this.isregistered == 'YES') {
                if (this.registrationtype == "" || this.registrationnumber == "" || this.registrationnumber == "" || this.certificateofincoporation == "") {
                    this.$toast.error("Fill businenes details");
                    return;
                }
            }
            let payload = {
                nameofbusiness: this.businessname,
                typeofbusiness: this.businesssector,
                businessaddress: this.businessaddress,
                isregistered: this.isregistered,
                occupationid: this.occupationId,
                registrationtype: this.registrationtype,
                regnumber: this.registrationnumber,
                certificateofincoporation: this.certificateofincoporation,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantBusinessData(JSON.stringify(payload)).then(res => {
                    // console.log("Business onwer", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },

        async submitEmployedNgo() {
            if (
                this.nameoforganisation == "" || this.jobtitle == "" || this.ngoeaddress == "" || this.dateofemployment == "" || this.ngoephone == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            let payload = {
                nameoforganisation: this.nameoforganisation,
                jobtitle: this.jobtitle,
                address: this.ngoeaddress,
                dateofemployment: this.dateofemployment,
                occupationid: this.occupationId,
                phone: this.ngoephone,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantEmployedNgoData(JSON.stringify(payload)).then(res => {
                    // console.log("Employed", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        },

        async submitUnemployedRetired() {
            if (
                this.uphone == "" || this.currentsourceofincome == "" || this.uaddress == "" || this.lastworkplace == "" || this.dateofdisengagement == ""
            ) {
                this.$toast.error("Fill required fields");
                return;
            }
            let payload = {
                currentsourceofincome: this.currentsourceofincome,
                lastworkplace: this.lastworkplace,
                address: this.uaddress,
                dateofdisengagement: this.dateofdisengagement,
                occupationid: this.occupationId,
                phone: this.uphone,
                tenant_id: this.tenantId,
            }
            this.loading = true;
            try {
                await properties.tenantUnemployedRetiredData(JSON.stringify(payload)).then(res => {
                    // console.log("Unemployed Retired", res);
                    this.loading = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            } finally {
                // console.log("closed")
            }
        }
    },
}
</script>



<style scoped lang="scss">


.holder {
    background: #ffffff;
    padding: 30px 15px;
}
.back-text {
   font-family: Lato;
   font-weight: 600;
   font-size: 16px;
   line-height: 24px;
   color: #535862;
   margin-bottom: 20px !important;
   cursor: pointer;
   span {
      padding-right: 10px;
   }
}

.top-header {
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #2B3352;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555C74;
    }

}

.top-buttons {
    display: flex;
    overflow: scroll;
    margin-top: 30px;
    // gap: 20px;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        color: #555C74;
        box-shadow: none;
        outline: 0;
        white-space: nowrap;
        border-radius: 0;
        padding-top: 15px !important;
        padding-bottom: 15px !important;
        padding-right: 50px !important;
        border-bottom: 1px solid #E9EAEB;
    }
}
.activeBtn {
    color: #0033EA !important;
    border-bottom: 1px solid #0033EA !important;
}

label {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #555C74;
}

input, select {
    height: 50px;
    border: 1px solid #D5D7DA !important;
    outline: 0 !important;
    box-shadow: none !important;
    width: 100%;
}

.save-btn {
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    width: 152px;
    padding: 10px;
    outline: 0;
    box-shadow: none;
    // float: right;
}

.upload-identification {
    border: 2px dashed #CCCCCC;
    border-radius: 8px;
    padding: 60px 20px;
    min-height: 199px;
    cursor: pointer;
    // margin: auto;
    img {
        display: flex;
        margin: auto;
    }
    h5 {
        margin-top: 20px;
        text-align: center;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: #0033EA;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #555C74;
    }
}

</style>